module.exports = __webpack_public_path__ + "f7e4ad1a4e85fbbae904be206d572d50.svg";